import { render, staticRenderFns } from "./ProductSelectorV2.vue?vue&type=template&id=65efb622&scoped=true&"
import script from "./ProductSelectorV2.vue?vue&type=script&lang=js&"
export * from "./ProductSelectorV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65efb622",
  null
  
)

export default component.exports